import Editor from "./src/index.vue";

Editor.install = function (Vue, options) {
  Vue.component(Editor.name, Editor);
};

export default Editor;
